<template>
  <div :class="[playVideo || registerable ? 'register-video' : '', 'register-or-video']">
    <RegisterButton v-if="registerable" :evEventOrCourse="evEventOrCourse" />
    <VideoButton v-else-if="playVideo" :evEventOrCourse="evEventOrCourse" />
  </div>
</template>

<script>
import RegisterButton from '@/components/events/RegisterButton.vue';
import VideoButton from '@/components/events/VideoButton.vue';

export default {
  props: {
    evEventOrCourse: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isPast() {
      return this.evEventOrCourse.start_date < new Date();
    },
    registerable() {
      return !this.isPast;
    },
    hasVideo() {
      return this.evEventOrCourse.video_link !== null;
    },
    playVideo() {
      return this.isPast && this.hasVideo;
    },
    width() {
      return '0px';
    },
  },

  components: {
    RegisterButton,
    VideoButton,
  },
};
</script>

<style scoped>
.register-or-video {
  display: none;
}

/** Larger devices and Landscape mobile */
@media only screen and (min-width: 601px) {
  .register-or-video {
    display: block;
  }
}

.register-video {
  margin-right: 0.5em;
}
</style>
